import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from 'semantic-ui-react'

const LoginButton = () => {
    const { loginWithRedirect } = useAuth0();

    return (
        <Button
            content="Log In"
            type="submit"
            labelPosition='right'
            icon='hand point left outline'
            onClick={() => loginWithRedirect()}
            positive
            floated='right'
        />
    )
};

export default LoginButton;